import styled from "styled-components";

export const LinkToPolicyReadOnlyRendrerStyled = styled.div`
  .break-link {
    word-break: break-all;
  }
`;
